module.exports = __webpack_public_path__ + "img/pokemon-go.ffd52bac.png";